import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("iwk_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const COVER_URL = "https://customer-assets.emergentagent.com/job_if-we-knew/artifacts/opnxm94f_471575A9-C6CC-4321-8547-8B7F5FA0781E.png";
export const HERO_BG = "https://customer-assets.emergentagent.com/job_if-we-knew/artifacts/opnxm94f_471575A9-C6CC-4321-8547-8B7F5FA0781E.png";
export const LOGO_URL = "https://customer-assets.emergentagent.com/job_if-we-knew/artifacts/8siswbyq_583BEEF8-BB07-4B01-873B-7319CBE2450A.png";
